module.exports = __webpack_public_path__ + "assets/bbea5ed35ab2e1141d7e9f65236270da.mp3";